import React from "react";
import "../styles/style.scss"; // Import the styles
import { Helmet } from "react-helmet";
import MetaTags from "../components/seo/MetaTags";

class Contacts extends React.Component {
  render() {
    return (
      <div role="main" className="mx-8 my-8 h-screen">
        <MetaTags
          name="description"
          content={
            "Contact page for Andrews Cookin, where you can reach out for questions, suggestions, or business inquiries."
          }
        ></MetaTags>
        <Helmet>
          <link
            rel="canonical"
            href="https://www.andrewscookin.com/contacts/"
          ></link>
        </Helmet>
        <h1>Contact Me</h1>
        <div className="px-64">
          If you have any questions, suggestions, want to buy an ad slot or business inquiries, feel
          free to reach out:
          <hr></hr>
          <div className="flex flex-col gap-4">
            <div className="row-span-1 text-center">
              <div className="text-center my-2">
                <span>
                  <img
                    src={process.env.REACT_APP_PUBLIC_URL + "/email.svg"}
                    className="contact-icon inline"
                    alt="Email link"
                  />
                  Business Email:{" "}
                  <a href="mailto:andrews.cooking133@gmail.com">
                    andrews.cooking133@gmail.com
                  </a>
                </span>
              </div>
              <div className="text-center my-2">
                <span>
                  <img
                    src={process.env.REACT_APP_PUBLIC_URL + "/email.svg"}
                    className="contact-icon inline"
                    alt="Email link"
                  />
                  Information, Suggestions etc. Email:{" "}
                  <a href="mailto:info@andrewscookin.com">
                    info@andrewscookin.com
                  </a>
                </span>
              </div>
            </div>
            <hr></hr>
            <div className="row-span-1 text-center">
              Socials:
              <div className="text-center my-2">
                <span className="">
                  <img
                    src={process.env.REACT_APP_PUBLIC_URL + "/instagram.svg"}
                    className="contact-icon inline"
                    alt="Instagram link"
                  />
                  Instagram:{" "}
                  <a
                    href="https://www.instagram.com/andrews_cookin/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    @andrews_cookin
                  </a>
                </span>
              </div>
              <div className="text-center my-2">
                <span className="">
                  <img
                    src={process.env.REACT_APP_PUBLIC_URL + "/tiktok.svg"}
                    className="contact-icon inline"
                    alt="Tiktok link"
                  />
                  TikTok:{" "}
                  <a
                    href="https://www.tiktok.com/@andrews_cookin?refer=creator_embed"
                    target="_blank"
                    rel="noreferrer"
                  >
                    @andrews_cookin
                  </a>
                </span>
              </div>
              <div className="text-center my-2">
                <span className="">
                  <img
                    src={process.env.REACT_APP_PUBLIC_URL + "/youtube.svg"}
                    className="contact-icon inline"
                    alt="YouTube link"
                  />
                  YouTube:{" "}
                  <a
                    href="https://www.youtube.com/@AndrewsCookin"
                    target="_blank"
                    rel="noreferrer"
                  >
                    @AndrewsCookin
                  </a>
                </span>
              </div>
            </div>
            <hr></hr>
          </div>
        </div>
      </div>
    );
  }
}
export default Contacts;
